import { Spinner } from 'spin.js';

import { getIframe } from '../helpers';

/**
 * spinnerStart 시작 이벤트
 */
export const spinnerStart = (whiteBG = false) => {
  // [로딩 부모 컨테이너 동적 생성]
  const createLayDiv = getIframe().createElement('div');
  createLayDiv.setAttribute('id', 'spinnerLay1000');
  let createLayDivStyle =
    'width:100%; height:100%; margin:0 auto; padding:0; border:none;';
  createLayDivStyle += ' float:top; position:fixed; top:0%; z-index:1000;';
  if (whiteBG) {
    createLayDivStyle += ' background-color: #ffffff;'; // 불투명도 설정 >> 자식에게 적용 안됨
  } else {
    createLayDivStyle += ' background-color:rgba(0, 0, 0, 0.3);'; // 불투명도 설정 >> 자식에게 적용 안됨
  }
  createLayDiv.setAttribute('style', createLayDivStyle);
  getIframe().body.appendChild(createLayDiv); //body에 추가 실시

  // [실제 스핀 수행 컨테이너 동적 생성]
  const createSpinDiv = getIframe().createElement('div');
  createSpinDiv.setAttribute('id', 'spinnerContainer1000');
  let createSpinDivStyle =
    'width:100px; height:100px; margin:0 auto; padding:0; border:none;'; // 스핀 컨테이너 크기 조절
  createSpinDivStyle += ' float:top; position:relative; top:40%;';
  createSpinDiv.setAttribute('style', createSpinDivStyle);
  getIframe().getElementById('spinnerLay1000').appendChild(createSpinDiv); //spinnerLay에 추가 실시

  // [스핀 옵션 지정]
  const opts = {
    lines: 10,
    color: '#ffffff',
  };

  // [스피너 매핑 및 실행 시작]
  const target = getIframe().getElementById('spinnerContainer1000');
  new Spinner(opts).spin(target);
};

/**
 * spinnerStop 중지 이벤트
 */
export const spinnerStop = () => {
  try {
    // [로딩 부모 컨테이너 삭제]
    const tagId = getIframe().getElementById('spinnerLay1000');
    getIframe().body.removeChild(tagId); //body에서 삭제
  } catch (exception) {
    // console.error("catch : " + "not find spinnerLay1000");
  }
};
